export default __webpack_public_path__ + "media/images/theme_apple/thumb-526f3d56c2652a0c753098a326161d14.png";